/**
 * Marca local de "alta terminada".
 *
 * El backend cachea `GET /accounts/{id}` durante 15 minutos y la lectura que
 * sigue al guardado devuelve todavía la versión anterior, sin
 * `metadata.onboarding.completed`. El guard de rutas lee ese campo, así que
 * durante esa ventana devolvía a /onboard a quien acababa de terminar el alta.
 *
 * Guardamos aquí, por cuenta, que el POST de completado salió bien: sobrevive a
 * recargas y deja de importar lo que conteste el GET mientras el caché caduca.
 */
const STORAGE_KEY = 'onboardingCompletedAccount';

export function markOnboardingCompleted(accountId) {
    if (!accountId) return;
    localStorage.setItem(STORAGE_KEY, accountId);
}

export function isOnboardingCompletedLocally(accountId) {
    if (!accountId) return false;
    return localStorage.getItem(STORAGE_KEY) === accountId;
}
